<ds-modal [title]="modalTitleAndActionName | translate" [maxWidthPercentage]="80" (modalClosed)="onCancel()">
  <div class="modal-content-wrapper">
    @if (restoreError) {
      <div class="mb-3">
        <p data-test-id="restore-error-message">{{ restoreError | translate }}</p>
      </div>
    }
    @if (!restoreError) {
      @if (changeTo === WorkspaceStateAction.archive) {
        <p>{{ 'archive_workspace_subtitle' | translate }}</p>
      } @else if (changeTo === WorkspaceStateAction.restore) {
        <p>{{ 'restore_workspace_subtitle' | translate }}</p>
      }
    }
    <div class="d-flex gap-3">
      @if (!restoreError) {
        <button ds-button [variant]="DsButtonVariants.primary" (click)="onChangeConfirmed()" data-test-id="confirm-button">
          {{ modalTitleAndActionName | translate }}
        </button>
        <button ds-button [variant]="DsButtonVariants.secondary" (click)="onCancel()" data-test-id="cancel-button">
          {{ 'label_cancel' | translate }}
        </button>
      } @else {
        <button ds-button [variant]="DsButtonVariants.primary" (click)="onCancel()" data-test-id="close-button">
          {{ 'label_close' | translate }}
        </button>
      }
    </div>
  </div>
</ds-modal>
